import React, { useEffect, useRef, useState } from "react";
/* eslint-disable import/no-anonymous-default-export */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCoverflow, } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-coverflow';


import 'swiper/css/autoplay';
import useIsMobileAndPortrait from "../../../../hooks/useIsMobile";
import { secureUrl } from "../../../../utils/sortArray/secureUrl";
import PlayerCard from "../GridPlayers/components/PlayerCard";
import './index.css'



const CarouselPlayers = ({players, vote})=>{
        const [numerSlides, SetNumberSlides] = useState(0)
        const  carouselRef= useRef()
        const imgChampionsRef = useRef(null)
        const getNumberOfSlides = ()=>{
            const getNumber = carouselRef.current?.offsetWidth / (imgChampionsRef.current?.offsetWidth || 400 + 100)
            SetNumberSlides(getNumber.toFixed(1))
        }
      const { isMobile, isPortrait} = useIsMobileAndPortrait();

        useEffect(()=>{
            if(!carouselRef.current) return
            getNumberOfSlides();
    
        },[carouselRef])
    
        useEffect(()=>{
            window.addEventListener('resize', ()=>{
                getNumberOfSlides();
            })
    
            return ()=> window.removeEventListener('resize', ()=>{})
    
        },[])



        const renderPlayers = ()=>{
            return players?.map((player, index)=>(createSlide(player)))

        }
        function createSlide(player) {
  return (
    <SwiperSlide>
        <PlayerCard  player={player?.jugador || player} handleVoteByPlayer={vote}/>
    </SwiperSlide>
  );
}

    return(
        <div ref={carouselRef}>
     <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={false}
        initialSlide={1}
        slidesPerView={2}
        slideToClickedSlide={true}
        touchStartPreventDefault={false}
        coverflowEffect={{
          rotate: 0,
          stretch: -50,
          depth:300,
          modifier: 0,
        }}
      modules={[Navigation, Pagination, Autoplay,EffectCoverflow]}
      navigation
    >
      {renderPlayers()}
    </Swiper>
        </div>
    )
}

export default CarouselPlayers